<template>
  <div>
    <div class="white-section mb-2">
      <b-form @submit.prevent class="mt-0">
        <b-row>
          <b-col md="4">
            <b-form-group
                :label="$t('section.sectionTitle')"
                label-for="unit-title"
                :invalid-feedback="
            invalidFeedbackTitle
              ? $t(`validation.${invalidFeedbackTitle}`, {
                  field: $t('unit.unitTitle'),
                })
              : ''
          "
            >
              <b-form-input autofocus
                  id="unit-title"
                  :state="$v.unitToEdit.title.$dirty ? !$v.unitToEdit.title.$invalid : null"
                  v-model="unitToEdit.title"
                  v-on:keyup.enter="onEnter"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group :label="$t('section.section')" label-for="unit-status">
              <b-form-select
                  text-field="title"
                  value-field="_id"
                  v-model="unitToEdit.sectionId"
                  :options="sections"
                  id="unit-section"
              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group :label="$t('general.status')" label-for="unit-status">
              <b-form-select
                  text-field="text"
                  value-field="value"
                  v-model="unitToEdit.status"
                  :options="statuses"
                  id="unit-status"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </div>

    <div class="white-section">
      <b-col md="12" class="text-right">
        <b-button
            size=""
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="info"
            @click="editUnit"
        >
          {{ $t("general.submit") }}
        </b-button>
      </b-col>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import Ripple from "vue-ripple-directive";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BFormSelect,
  BFormInvalidFeedback,
  BBreadcrumb,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
export default {
  data() {
    return {
      items: [
        {
          text: this.$t('unit.units'),
          to: {name: "manageUnit"}
        },
        {
          text: this.$t('unit.editUnit'),
          active: true
        }
      ],
      createAutomaticRecallNumber:true

    }
  },
  mounted() {
    this.unitToEdit.sectionId = this.unitToEdit.getSection._id
  },
  directives: {
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BFormSelect,
    BFormInvalidFeedback,
    BBreadcrumb,
  },
  validations() {
    return {
      unitToEdit: {
        title: {
          required,
        },
      }
    };
  },
  computed: {
    invalidFeedbackTitle: {
      set(error) {},
      get() {
        let  error = "";
        if (!this.$v.unitToEdit.title.$dirty) return error;
        if (!this.$v.unitToEdit.title.required) error = "required";
        return error;
      },
    },
    ...mapGetters({
      statuses: "general/statuses",
      sections: 'sections/sections'
    }),
    unitToEdit: {
      set(unitToEdit) {
        this.$store.commit("units/SET_UNIT_TO_EDIT", unitToEdit);
      },
      get() {
        return this.$store.getters["units/unitToEdit"];
      },
    },
    
  },
  methods: {
    onEnter(){
      this.editUnit()
    },
    editUnit() {
        const payload = {
          title: this.unitToEdit.title,
          status: this.unitToEdit.status,
          sectionId: this.unitToEdit.sectionId,
          // createAutomaticRecallNumber : this.unitToEdit.createAutomaticRecallNumber,
        };
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$store.commit('SET_IS_LOADING', true)
        this.$store
            .dispatch("units/updateUnit", {
              id: this.unitToEdit._id,
              payload: payload,
            })
            .then(() => {
              this.$store.commit('SET_IS_LOADING', false)
              this.$bvToast.toast(this.$t('toastification.submissionSucceed'), {
                title: this.$t('toastification.success'),
                variant: 'success',
                solid: true,
              });
              this.$router.push({name: "manageUnit"});
            })
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$t('toastification.failedAction'),
                  content: this.$t('toastification.failedAction'),
                  icon: 'EditIcon',
                  variant: 'danger',
                },
              })
              this.$store.commit('SET_IS_LOADING', false)
            });
      }else{
        this.$nextTick(() => {
        const el = document.querySelector(".is-invalid:first-of-type");
        
        el.scrollIntoView({ behavior: 'instant', block: 'center' });
        // el.scrollIntoView();
        return;
        })
      }
    },
    setCreateAutomaticRecallNumber(event){
      this.unitToEdit.createAutomaticRecallNumber = event;
    }
  },
  created() {
    this.$store.dispatch('sections/searchSection',{status : 'active'});
        let params = this.$route.params;
        this.$store.dispatch('units/getUnitToEdit', params.id).then(res=>{
          this.pushBreadcrumb({text: 'editUnit', to:{name:'editUnit' }, translate:true});
          this.pushBreadcrumb( {text: res.title , translate:false});
          this.setCurrentBreadcrumb([{text: 'editUnit', to:{name:'editUnit' }, translate:true},{text: res.title , translate:false} ]);
        })
  },
};
</script>